export default __webpack_public_path__ + "static/granulation-e3b7d0d8fa24877c09d01ce1c8d33567.png";